import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import dynamic from 'next/dynamic';
import { faStore } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import { DataTestId } from '@utils/test';

const Tooltip = dynamic(
  () => import('@components/main-components/tooltip/Tooltip').then(mod => mod.Tooltip),
  {
    ssr: false,
  },
);

const TooltipTrigger = dynamic(
  () => import('@components/main-components/tooltip/Tooltip').then(mod => mod.Tooltip.Trigger),
  { ssr: false },
);

const TooltipContent = dynamic(
  () =>
    import('@components/main-components/tooltip/Tooltip').then(mod => mod.Tooltip.StyledContent),
  { ssr: false },
);

export function SecondaryBadge({ marketPlaceUrl }: { marketPlaceUrl: string | null }) {
  return (
    <Tooltip openOnClick={false} delayCloseMs={1000}>
      <TooltipTrigger>
        <div
          data-testid={DataTestId.SECONDARY_BADGE}
          className={clsx(
            'flex h-6 flex-shrink-0 items-center rounded-sm bg-base900 px-1',
            'line font-base text-base-s font-semibold text-white',
          )}
        >
          <FontAwesomeIcon icon={faStore} />
        </div>
      </TooltipTrigger>
      <TooltipContent className="w-52 text-center font-base !text-base-s">
        Collection is sold out. Collect the cheapest available edition from{' '}
        {marketPlaceUrl ? (
          <AccessibleLink absoluteUri={marketPlaceUrl} type="external">
            <span className="underline">Sound Market.</span>
          </AccessibleLink>
        ) : (
          <span>Sound Market.</span>
        )}
      </TooltipContent>
    </Tooltip>
  );
}
